<template>
  <section style="overflow-x: hidden" v-if="contentFetched">
    <!--intro section-->
    <!--background image snippets-->
    <div
      v-rellax="{ speed: -6 }"
      class="about-left position-absolute d-none d-lg-block"
    >
      <img
        height="700px"
        src="../../assets/img/about-left.png"
        alt=""
        class=""
      />
    </div>
    <div
      v-rellax="{ speed: -6 }"
      class="about-right position-absolute d-none d-lg-block"
    >
      <img
        height="900px"
        src="../../assets/img/about-right.png"
        alt=""
        class=""
      />
    </div>

    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
          <h1
            id="head-title"
            class="page-title text-gradient"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
          >
            About <br />
            Leicester Caribbean Carnival
          </h1>
          <div
            id="scroll-down"
            class="d-flex justify-content-center my-5 animated bounce w-100"
            style="z-index: 1"
          >
            <span
              class="bg-white shadow-sm section-nav pointer"
              @click="scrollToSection('page-content')"
              data-aos="fade-down"
              data-aos-duration="3000"
              data-aos-easing="ease-in-out-back"
              data-aos-offset="-500"
              data-aos-once="true"
            >
              <img src="../../assets/svg/arrow-down.svg" alt="" class="" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <!--END intro section-->

    <!--About-text-->
    <div class="container">
      <div class="row">
        <div
          class="col-10 offset-1 col-lg-6 offset-lg-3 col-xl-8 offset-xl-2 text-center"
        >
          <h6
            class="about-sub-heading my-5"
            data-aos="fade-up"
            data-aos-once="true"
          >
            HOW IT ALL BEGAN
          </h6>
          <h6
            class="about-sub-heading my-5"
            data-aos="fade-up"
            data-aos-once="true"
          >
            {{ content.summary }}
          </h6>
          <div id="page-content">
            <p
              class="about-text"
              data-aos="fade-up"
              data-aos-once="true"
              v-for="(part, index) in content.body.split('\n\n')"
              :key="index"
            >
              {{ part }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--END About-text-->

    <!--carnival themes-->
    <div class="img-schedule mt-5 py-95">
      <div class="container">
        <div v-rellax="{ speed: -1, center: true }" class="row">
          <div class="col-12 text-center">
            <h4 class="themes-head text-gradient mb-5 font-weight-bold">
              Themes from 1985 to present
            </h4>
          </div>
          <div
            class="themes col-lg-3 text-white"
            data-aos="zoom-out"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
            v-for="(chunk, index) in themeChunks"
            :key="`chunk_${index}`"
          >
            <ul class="list-unstyled">
              <li
                class=""
                v-for="(theme, index) in chunk"
                :key="`theme_${index}`"
              >
                <strong>{{ theme.year }}</strong
                >&nbsp;{{ theme.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--carnival themes-->
  </section>
</template>

<script>
import { mapState } from 'vuex';
import isBefore from 'date-fns/is_before';
import { dbRefs } from '../../services/firebase/init';
import EventMixin from '../../mixins/eventInfo';

export default {
  data() {
    return {
      content: {},
      contentFetched: false,
    };
  },
  mixins: [EventMixin],
  //    firestore: {
  //      content: dbRefs.aboutRef,
  //      themes: dbRefs.themesRef
  //    },
  computed: {
    ...mapState({
      themes: (state) => state.content.themes,
    }),
    themeChunks() {
      const themesSorted = [...this.themes].sort((a, b) => {
        if (isBefore(new Date(a.year), new Date(b.year))) {
          return -1;
        } else {
          return 1;
        }
      });
      return _.chunk(themesSorted, 9);
    },
  },
  async mounted() {
    const [content] = await Promise.all([
      this.fetchDocument(dbRefs.aboutRef),
      this.fetchCollection({ ref: dbRefs.themesRef, collectionName: 'themes' }),
    ]);
    this.content = content;
    this.contentFetched = true;
  },
};
</script>

<style scoped lang="scss">
.py-95 {
  padding: 95px 0;
}

.about-left {
  top: 20%;
}

.about-right {
  right: 0px;
  top: 13%;
}

.about-sub-heading {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.69;
  letter-spacing: -0.2px;
  /*text-align: center;*/
  color: #565887;
}

.about-text {
  /*font-family: Helvetica;*/
  font-size: 15px;
  line-height: 1.8;
  /*text-align: center;*/
  color: #565887;
}

.themes-head {
  background-image: linear-gradient(to right, #ff4c86, #ffbd15),
    linear-gradient(to bottom, #565887, #565887);
  font-size: 20px;
  font-weight: bold;
  line-height: 1.07;
  letter-spacing: -0.3px;
  color: #565887;
  /*-webkit-background-clip: text;*/
  /*background-clip: text;*/
  /*-webkit-text-fill-color: transparent;*/
}

.themes {
  font-size: 14px;
  line-height: 2.14;
  letter-spacing: -0.1px;
}

.list-unstyled {
  li {
    transition: color 0.5s;

    &:hover {
      color: $lilac;
    }
  }
}
</style>
